<template>
  <div class="yxtbiz-teacher-level">
    <div class="pr" :class="{'yxtbiz-teacher-level-iserror':error }">
      <yxt-select
        v-model="valueIds"
        :multiple="multiple"
        :placeholder="$t('pc_biz_te_lbl_level'/*级别*/)"
        clearable
        :fixed-left-padding="40"
        popper-class="yxtbiz-teacher-level-select"
        @change="change"
        @blur="blur"
        :size="size"
        :style="style">
        <yxt-option
          v-for="item in optionsData"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></yxt-option>
        <div v-if="optionsData.length" slot="fixed-left" class="pl12 pt15 standard-size-12 color-gray-7">
          <div>{{ $t('pc_biz_te_lbl_lowLevel'/* 低 */) }}</div>
          <yxt-svg :remote-url="PcSvgUrl"
                  width="14px"
                  :height="optionsData.length > 4 ? '142px': optionsData.length === 4 ? '96px' : '62px'"
                  :icon-class="optionsData.length > 4 ? 'level-noedit' : optionsData.length === 4 ? 'level-noedit4' : 'level-noedit3'" />
          <div>{{ $t('pc_biz_te_lbl_heightLevel'/* 高 */) }}</div>
        </div>
      </yxt-select>
      <div v-if="error" class="yxtbiz-teacher-level_errorText">{{ errorText }}</div>
    </div>
  </div>
</template>

<script>
import { getTeLevelList } from './service';
import { Select, Option } from 'yxt-pc';
export default {
  name: 'YxtbizTeacherLevel',
  name_zh: '讲师级别下拉框',
  eventList: [
    {
      type: 'blur', // 抛出的事件名
      handler: 'onBlur', // 事件处理函数
      label: '点击选择后的事件' // 事件描述
    },
    {
      type: 'change', // 抛出的事件名
      handler: 'onChange', // 事件处理函数
      label: '点击选择后的事件' // 事件描述
    }
  ],
  components: {
    YxtSelect: Select,
    YxtOption: Option
  },
  props: {
    // 当前选择的级别集合
    defaultValue: {
      type: Array,
      default: () => {
        return [];
      },
      desc: '当前选择的级别集合',
      setter: 'JsonSetter'
    },
    // 是否多选模式
    multiple: {
      type: Boolean,
      default: true,
      desc: '是否多选模式',
      setter: 'BooleanSetter'
    },
    // 选择框尺寸
    size: {
      type: String,
      default: '',
      desc: '输入框尺寸',
      setter: 'StringSetter'
    },
    // 选择框长度
    setwidth: {
      type: String | Number,
      desc: '输入框长度',
      setter: 'NumberSetter'
    },
    // 是否校验提示
    error: {
      type: Boolean,
      default: false,
      desc: '是否校验提示',
      setter: 'BooleanSetter'
    },
    // 校验为空提示文案
    errorText: {
      type: String,
      default: '校验为空提示文案',
      desc: '校验为空提示文案',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      PcSvgUrl: `${this.$staticBaseUrl}ufd/55a3e0/te/pc/svg`,
      value: undefined, // 初始选中数据
      options: [] // 级别数组
    };
  },
  computed: {
    style() {
      return {
        width: this.setwidth + 'px'
      };
    },
    // change事件，返回对象
    optionsKeyLable() {
      const obj = {};
      for (let index = 0; index < this.options.length; index++) {
        obj[this.options[index].value] = this.options[index].label;
      }
      return obj;
    },
    // 选项数据回显
    valueIds: {
      get() {
        return this.value || this.defaultValue.map(_ => _.value);
      },
      set(value) {
        this.value = value;
      }
    },
    // 列表数据
    optionsData() {
      return this.options.length ? this.options : this.defaultValue;
    }
  },
  methods: {
    blur() {
      this.$emit('blur');
    },
    // 选择级别
    change(datas) {
      if (datas && datas.length) {
        this.$emit('change', datas.map(_ => ({
          value: _,
          label: this.optionsKeyLable[_]
        })));
      } else {
        this.$emit('change', datas && this.optionsKeyLable[datas]);
      }
    },
    // 获取目录信息
    getLevelList() {
      getTeLevelList().then(points => {
        this.options = [];
        points.forEach((e) => {
          this.options.push({
            label: e.name,
            value: e.id
          });
        });
      });
    }
  },
  created() {
    this.getLevelList();
  }
};
</script>
